import React, { useEffect, useRef, useState, } from 'react'
import { createSessionifMissing, getMUICache, loadStyles, httpMiddleware, logoutUserSession, updateSessionObject, getSessionObject } from '../../core/Utils';
import Grid from '@mui/material/Grid';
import { CacheProvider } from '@emotion/react';
// import DashBoard from './DashBoard.css'
import LandingPage from './LandingPage.css'
import logoImage from "../../images/dashboard-logo.svg";
import OrgIcon from "../../images/org-icon.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPowerOff } from '@fortawesome/free-solid-svg-icons';
import Tooltip from '@mui/material/Tooltip';
import { PAGE_BUILDER_ENDPOINTS, CONSTANTS, CONST_PERMISSIONS } from "../../core/constants";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { FeedExportComponent } from '../FeedExport';
import { UserSessionComponentOtherPages } from '../../core/Service/PageUserSessionService';



const LandingMainPage = (props) => {
    const cache = getMUICache();
    const [show, setShow] = useState(false);
    const [dropShow, setDropShow] = useState(false);
    const [webListShow, setWebListShow] = useState(false);
    const [activeState, desabileState] = useState(false);
    const [activeStateLog, desabileStateLog] = useState(false);
    const [activeWebList, desabileWebList] = useState(false);
    const [userEmail, setUserEmail] = useState("");
    const refOne = useRef(null);
    const refTwo = useRef(null);
    const refThree = useRef(null);
    const [websitOptions, setOptions] = useState([]);
    const [websiteValue, setWebsiteValue] = useState({});
    const [feedExportPage, setFeedExportPage] = useState(false);
    const link = document.querySelector("link[rel~='icon']");
    const dymincUrl = "https://pagebuilder.publishstory.co";
    const [listJson, setListJson] = useState([{
        title: "Authoring",
        desc: "Craft Compelling Content, Welcome to your Authoring Module of Publish Story, the heart of content creation within our CMS! Here, you have everything you need to transform your ideas into engaging content, easily and efficiently.",
        imgPath: dymincUrl + "/stresources/custom-icons/uthoring_org.svg",
        imgPathHover: dymincUrl + "/stresources/custom-icons/Authoring_selected.svg",
        // path: "https://app.publishstory.co/authoring",
        path: "/authoring",
    },
    {
        title: "Admin Management",
        desc: "Welcome to your Admin Module, the nerve center of Publish Story. Here, you have complete control over managing content, users, settings, and ensuring a smooth operation for your website.",
        imgPath: dymincUrl + "/stresources/custom-icons/dmin_org.svg",
        imgPathHover: dymincUrl + "/stresources/custom-icons/admin_org.svg",
        // path: "https://app.publishstory.co/admin",
        path: "/admin",
    },

    {
        title: "Analytics",
        desc: "Unveiling the Power of Data on Publish Story. Here's where content meets insights. We provide the tools to analyse your content's performance and make data-driven decisions that optimise your website's success.",
        imgPath: dymincUrl + "/stresources/custom-icons/nalytics_org.svg",
        imgPathHover: dymincUrl + "/stresources/custom-icons/Analytics_selected.svg",
        // path: "https://app.publishstory.co/analytics/",
        path: "/analytics/",
    },


    {
        title: "Reporting",
        desc: "Publish your story, then delve into the data to measure its impact. Publish Story Reporting Module provides valuable insights to understand how your content performs, empowering you to refine your strategy and achieve success.",
        imgPath: dymincUrl + "/stresources/custom-icons/eporting_org.svg",
        imgPathHover: dymincUrl + "/stresources/custom-icons/Analytics_selected.svg",
        // path: "https://app.publishstory.co/reporting/cms-analytics/",
        path: "/reporting/cms-analytics/",
    },


    {
        title: "Page Builder",
        desc: "Welcome to the Page Builder Module, your one-stop shop for crafting stunning and engaging website pages! This intuitive drag-and-drop interface empowers you to bring your content vision to life, with no coding required.",
        imgPath: dymincUrl + "/stresources/custom-icons/age_builder_org.svg",
        imgPathHover: dymincUrl + "/stresources/custom-icons/Page_Builder_selected.svg",
        // path: "https://app.publishstory.co/pagebuilder",
        path: "/pagebuilder",

    }]);


    function handleClick() {
        desabileState(activeState => !activeState);
    }
    function handleLogout() {
        desabileStateLog(activeStateLog => !activeStateLog);
    }
    const disabledStyle = {
        pointerEvents: 'none',
        opacity: 0.5,
    };

    useEffect(() => {
        createSessionifMissing().then(res => {
            if (res && res && res?.tokenPayload?.userEmail) {
                let userEmail = res.tokenPayload.userEmail;
                setUserEmail(userEmail);

                if (
                    //res.permissions && res.websiteId && res.permissions.find((op) => op.websiteId === res.websiteId) !== undefined
                    //&& res.permissions.find((op) => op.websiteId === res.websiteId).permission.includes(CONST_PERMISSIONS.WEBSITE_CHANNEL_CREATION)
                    res.tenantIdPermissions && res.tenantIdPermissions.includes(CONST_PERMISSIONS.WEBSITE_CHANNEL_CREATION)) {
                    setListJson([...listJson,
                    {
                        title: "New Channel Creation",
                        desc: "Your stories deserve to be heard! Create New Channel within Publish Story, empowering you to publish your content on various platforms and reach a wider audience.",
                        imgPath: dymincUrl + "/stresources/custom-icons/hannel_creation_org.svg",
                        imgPathHover: dymincUrl + "/stresources/custom-icons/Channel_Configration_selected.svg",
                        // path: "https://app.publishstory.co/pagebuilder#createSite",
                        path: "/pagebuilder#createSite",
                    },
                    {
                        title: "Custom Feed",
                        desc: "Empower your content to reach new audiences. Create and export custom news feed tailored for specific partners and aggregators, all while maintaining control over your valuable content.",
                        imgPath: dymincUrl + "/stresources/custom-icons/publish_story_custom_feed_icon.svg",
                        imgPathHover: dymincUrl + "/stresources/custom-icons/Channel_Configration_selected.svg",
                        // path: "https://app.publishstory.co/dashboard/customfeed",
                        path: "/dashboard/customfeed",
                    }])
                } else {
                    setListJson([...listJson,
                    {
                        title: "New Channel Creation",
                        desc: "Your stories deserve to be heard! Create New Channel within Publish Story, empowering you to publish your content on various platforms and reach a wider audience.",
                        imgPath: dymincUrl + "/stresources/custom-icons/hannel_creation_org.svg",
                        imgPathHover: dymincUrl + "/stresources/custom-icons/Channel_Configration_selected.svg",
                        // path: "https://app.publishstory.co/pagebuilder#createSite",
                        path: "/pagebuilder#createSite",
                        onclick: true
                    },
                    {
                        title: "Custom Feed",
                        desc: "Empower your content to reach new audiences. Create and export custom news feed tailored for specific partners and aggregators, all while maintaining control over your valuable content.",
                        imgPath: dymincUrl + "/stresources/custom-icons/publish_story_custom_feed_icon.svg",
                        imgPathHover: dymincUrl + "/stresources/custom-icons/Channel_Configration_selected.svg",
                        // path: "https://app.publishstory.co/dashboard/customfeed",
                        path: "/dashboard/customfeed",
                    }])
                }

                document.addEventListener("click", handleClickOutside, true);

                // document.addEventListener("click", handleClickLogButton, true);
                document.addEventListener("click", handleClickWebList, true);

                // Make an API request to fetch your data
                const config = {
                    method: 'GET',
                    url: PAGE_BUILDER_ENDPOINTS.DOMAIN + "/getAllWebsitesByClient",
                };

                httpMiddleware(config)
                    .then((response) => {
                        if (!response.status) {
                            throw new Error('Network response was not ok');
                        }

                        return response.data;
                    })
                    .then((data) => {
                        if (data && data.length > 0) {
                            setOptions(data.filter((item) => item.status === true));
                            let website;
                            if(res?.tokenPayload?.hostId) website = data.filter((item) => (item.status === true && item.denmarkObject?.hostId === res?.tokenPayload?.hostId))[0];
                            else website = data.filter((item) => item.status === true)[0];
                            if(!website) website = data.filter((item) => item.status === true)[0];
                            setWebsiteValue(website);
                            updateSessionObject("hostId", website?.denmarkObject?.hostId);
                            updateSessionObject("metaData", website?.websiteId, "websiteId");
                        }
                    })
                    .catch((error) => {
                        console.error("Error fetching data:", error);
                    });
            }


        });
        // add newtitle
        document.title = 'PublishStory Dashboard';


        if (link !== null) {
            link.href = 'https://pagebuilder.publishstory.co/stresources/custom-icons/PS%20favicon.ico'; // Replace '/favicon-page1.ico' with your favicon path for Page 1
        };

        /*--------ninedots----------*/


        /*--------ninedots----------*/

    }, []);

    const handleClickOutside = (e) => {
        if (refOne && refOne.current && refOne.current.contains(e.target)) {
            // console.log("clicked in side one")
        } else {
            // console.log("clicked out side one")
            setShow(0);
        }

    }

    // const handleClickLogButton = (e) => {

    //     if (refTwo && refTwo.current && refTwo.current.contains(e.target)) {
    //         console.log("clicked in side two")
    //     } else {
    //         console.log("clicked out side two")
    //         setDropShow(0);
    //     }

    // }

    const handleClickWebList = (e) => {

        if (refThree && refTwo.current && refTwo.current.contains(e.target)) {
            // console.log("clicked in side three")
        } else {
            // console.log("clicked out side two")
            setWebListShow(0);
        }

    }


    function getInitials(input) {
        const words = input.split(" ");
        const initials = words.map(word => word.charAt(0));
        if (initials.length === 1) {
            return initials[0].toUpperCase();
        }
        return (initials[0] + initials[1]).toUpperCase();
    }

    let company_name = "Company Name";
    let company_email = "company.name@gmail.com";
    let company_name_initials = "CN";
    if (sessionStorage.getItem("metaData") && JSON.parse(sessionStorage.getItem('metaData')).name) {
        company_name = JSON.parse(sessionStorage.getItem('metaData')).name;
        company_name_initials = getInitials(company_name);
        if (JSON.parse(sessionStorage.getItem("metaData")).tokenPayload && JSON.parse(sessionStorage.getItem("metaData")).tokenPayload.userEmail) {
            company_email = JSON.parse(sessionStorage.getItem("metaData")).tokenPayload.userEmail;
        }
    }

    function getlogoImageUrl(data) {
        console.log("CONSTANTS : ", CONSTANTS);
        if (data.websiteDomain && data.websiteResouces && data.websiteResouces.schemaLogo && CONSTANTS && CONSTANTS.API_URL && CONSTANTS.API_URL.VSP_IMAGES) {
            if (CONSTANTS.API_URL.VSP_IMAGES == "") {
                return 'https://' + data.websiteDomain + '/thumb/' + data.websiteResouces.schemaLogo + '.cms?imgsize=422424&amp;width=96&amp;resizemode=4';
            } else {
                return CONSTANTS.API_URL.VSP_IMAGES + '/thumb/' + data.websiteResouces.schemaLogo + '.cms?imgsize=422424&amp;width=96&amp;resizemode=4';
            }
        } else {
            return OrgIcon
        }
    }

    const landingNinedotsJson = [
        // {
        //     mediaPath:dymincUrl + "/stresources/custom-icons/home.svg",
        //     mediaHoverPath:dymincUrl + "/stresources/custom-icons/home_selected.svg",
        //     links:[
        //         {
        //             title: "Home",
        //             path:"https://app.publishstory.co/dashboard/"
        //         }
        //     ]
        // },
        {
            mediaPath: dymincUrl + "/stresources/custom-icons/Authoring_denmark.png",
            // mediaHoverPath:dymincUrl + "/stresources/custom-icons/denmark_selected.svg",
            links: [
                {
                    title: "Authoring",
                    // path: "https://app.publishstory.co/authoring/"
                    path: "/authoring/"
                }
            ]
        },

        {
            mediaPath: dymincUrl + "/stresources/custom-icons/Reporting_cmsanalytics.png",
            // mediaHoverPath:dymincUrl + "/stresources/custom-icons/ibeat_selected.svg",
            links: [
                {
                    title: "Reporting",
                    // path: "https://app.publishstory.co/reporting/cms-analytics/"
                    path: "/reporting/cms-analytics/"
                }
            ]
        },

        {
            mediaPath: dymincUrl + "/stresources/custom-icons/Analytics_ibeat.png",
            // mediaHoverPath:dymincUrl + "/stresources/custom-icons/cmsanalytics_selected.svg",
            links: [
                {
                    title: "Analytics",
                    // path: "https://app.publishstory.co/analytics/"
                    path: "/analytics/"
                }
            ]
        },

        {
            mediaPath: dymincUrl + "/stresources/custom-icons/Pagebuilder_m360.png",
            // mediaHoverPath:dymincUrl + "/stresources/custom-icons/dots-page_builder_selected.svg",
            links: [
                {
                    title: "Page Builder",
                    // path: "https://app.publishstory.co/pagebuilder/"
                    path: "/pagebuilder/"
                }
            ]
        },

        {
            mediaPath: dymincUrl + "/stresources/custom-icons/assetmanager_chronicle.png",
            // mediaHoverPath:dymincUrl + "/stresources/custom-icons/denmark_selected.svg",
            links: [
                {
                    title: "Asset Manager",
                    path: "/"
                }
            ]
        },


        {
            mediaPath: dymincUrl + "/stresources/custom-icons/Admin_coral.png",
            // mediaHoverPath:dymincUrl + "/stresources/custom-icons/Chronicle_selected.svg",
            links: [
                {
                    title: "Admin",
                    // path: "https://app.publishstory.co/admin/"
                    path: "/admin/"
                }
            ]
        },
        {
            mediaPath: dymincUrl + "/stresources/custom-icons/Comment moderator.png",
            // mediaHoverPath:dymincUrl + "/stresources/custom-icons/ibeat_selected.svg",
            links: [
                {
                    title: "Comment Moderator",
                    path: "/",
                }
            ]
        },


        {
            mediaPath: dymincUrl + "/stresources/custom-icons/VideoAuthoring_slike.png",
            // mediaHoverPath:dymincUrl + "/stresources/custom-icons/ibeat_selected.svg",
            links: [
                {
                    title: "Video Authoring",
                    path: "/"
                }
            ]
        }





    ]

    function onHostSwitch(callback) {
        const hostId = getSessionObject("hostId"); // Retrieve the updated hostId
        window.iamAuthSDK.onHostSwitch(hostId, callback);
    }

    function websiteOnChange(event) {
        if (event.target) {
            updateSessionObject("metaData", event.target.value.websiteId, "websiteId");
            updateSessionObject("hostId", event.target.value.denmarkObject.hostId);
            setWebsiteValue(event.target.value);

            // Trigger the host switch and provide a callback
            onHostSwitch((data) => {
                console.log("Host switch callback data:", data);
            });
        }
    }


    const footerLinksJson = [
        {
            links: [
                {
                    title: "All rights reserved",
                    // path: "/dashboard/copyright"
                },
                {
                    title: "Privacy Policy",
                    path: "/dashboard/privacy-policy"
                },
                {
                    title: "Terms & Conditions and Grievance Redressal Policy",
                    path: "/dashboard/terms-conditions"
                },
                {
                    title: "About us",
                    // path: "/dashboard/about"
                }

            ]
        },

    ]
    // /thumb/104894223.cms?imgsize=422424&amp;width=96&amp;resizemode=4

    if (!(userEmail)) {
        return <></>
    }

    return (userEmail !== '' ? (
        <>
            <UserSessionComponentOtherPages />
            <div className='MainBodyWrapper' styles={LandingPage}>
                <div className='LandingPageHeader'>
                    <div className='LandingPageHeaderWrapper'>
                        <div className='LandingPageLogo'>
                            <figure><img src={logoImage} /></figure>
                        </div>
                        <div className='RightSideMenuWrap'>
                            <div className='MenuSelectItems'>
                                <p className='inNewsroomTiitle'>Newsroom</p>
                                <FormControl sx={{ m: 1, minWidth: 150 }}>
                                    <Select labelId="SelectPublisher"
                                        id="SelectPublisherHelper"
                                        label="publishers"
                                        value={websiteValue}
                                        onChange={websiteOnChange}>
                                        {websitOptions.map((data, i) => {
                                            return <MenuItem key={'jj_' + i} className='slectItemsCommon' value={data}>
                                                <img src={getlogoImageUrl(data)} />
                                                {data.websiteName}</MenuItem>

                                        })}
                                    </Select>
                                </FormControl>
                            </div>
                            {/* <div className='moreAppsWrapper' id='_9dots_more_apps_wrapper'></div> */}
                            {/* 
                            <div className={`AppsIconsWrap ${activeState ? "activeState" : ''}`} onClick={handleClick}>
                                <button onClick={() => setShow(!show)} className='dotsButton' ref={refOne}> <AppsIcon></AppsIcon></button>
                                {show ? <div className='ShowIconsOnClick'>
                                    <ul>
                                        {landingNinedotsJson.map((data, i) => {
                                            console.log('data', data);

                                            return <li key={i + "1"}>
                                                {data.links && data.links.length > 0 && data.links.map((item, l) => {
                                                    return <a href={item.path} target='_blank' key={l + "3"}><i className='IconWrap'>
                                                        <figure className='nineDotsIcon'><img src={data.mediaPath} /></figure>
                                                        <figure className='nineDotsIconSelected'><img src={data.mediaHoverPath} /></figure>
                                                    </i><span>{item.title}</span></a>
                                                })}
                                            </li>

                                        })}
                                    </ul>

                                </div> : null
                                }
                            </div> */}

                            <div className={`UserNameWrap ${activeStateLog ? "activeStateLog" : ''}`} onClick={handleLogout}>
                                <button className='logButtonDrop' onClick={() => setDropShow(!dropShow)} ref={refTwo}>{company_name_initials}</button>
                                {dropShow ? <div className='logOutWrap'>
                                    <div className='userDetailsWrap'>
                                        <div className='userNameDetails'>{company_name}</div>
                                        <div className='userEmailDetails'>{company_email}</div>
                                    </div>
                                    <Tooltip title="Logout">
                                        <button onClick={logoutUserSession}><FontAwesomeIcon icon={faPowerOff} /> Logout</button>
                                    </Tooltip>
                                </div> : null
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className='fix-wrapper'>
                    <CacheProvider value={cache}>
                        <Grid container>
                            <Grid item md={12} xs={12}>
                                <div className='LandingTopWrapper'>
                                    <div className='LandingHeading'>

                                        {/* <p>WELCOME {userEmail},</p> */}
                                        <p className='welcomeText'>Welcome {company_name} <span className='companyName'></span></p>
                                    </div>
                                    <div className='LandingWelcomeText'>
                                        <p> You 're now officially logged in and ready to embark on your storytelling journey.</p>
                                        <p>Explore your dashboard to discover various sections and platforms available
                                            for you, track your submissions, and engage with readers on our vibrant platform. Thank you for choosing Publish Story as your creative partner.Your words have the power to captivate, inspire, and transform lives.</p>
                                        <p>Let 's make magic together. <span className='happyWriting'>Happy writing!</span> </p>
                                    </div>
                                </div>
                            </Grid>
                            <div className='Rowside'>
                                {listJson.map((val, j) => {
                                    let isDisabled = false;
                                    if (val.onclick !== undefined && val.onclick === true) {
                                        isDisabled = true;
                                    }
                                    return <a href={val.path} rel="noopener noreferrer" target='_blank' className='LandingPageTiles CommonLandingTIles' style={isDisabled ? disabledStyle : null} key={j + "2"}>
                                        <div className='LandingtilesHeadingWrapper'>
                                            <div className='IconWrapper'>
                                                <figure className='UserImage current'><img src={val.imgPath} /></figure>
                                                {/* <figure className='UserSelectedImage afterHover'><img src={val.imgPathHover} /></figure> */}
                                            </div>
                                            <p>{val.title}</p>
                                        </div>
                                        <div className='LandingTilesText'>
                                            <p>{val.desc}</p>
                                        </div>
                                        <div className='LandingTilesLinks'>
                                            <ul>
                                                {val.links && val.links.length > 0 && val.links.map((item, k) => {
                                                    return <li key={j + "_" + k + "3"}><a rel="noopener noreferrer" target='_blank' href={item.path}>{item.title}</a></li>
                                                })}
                                            </ul>
                                        </div>
                                    </a>
                                })}
                            </div>
                        </Grid>
                    </CacheProvider>
                </div>
                <div className='landingPageFooter'>
                    <CacheProvider value={cache}>
                        <Grid container>
                            <Grid item md={12} xs={12}>
                                <div className='landingFooterText'>
                                    <p>publishstory.co , Copyright © 2024 Times Internet Ltd.</p>
                                </div>

                                <div className='landingFooterLinks'>
                                    <ul>
                                        {footerLinksJson.map((data, i) => {
                                            return <li key={i}>
                                                {data.links && data.links.length > 0 && data.links.map((item, l) => {
                                                    return <a rel="noopener noreferrer" target='_blank' href={item.path} key={l}><span>{item.title}</span></a>
                                                })}
                                            </li>

                                        })}
                                    </ul>
                                </div>
                            </Grid>
                        </Grid>
                    </CacheProvider>
                </div>
            </div >
        </>
    ) : (<></>));
}

export default LandingMainPage;

